export function Spinner({ label }: { label?: string }) {
  return (
    <span role="status" aria-label={label ?? 'Lädt …'}>
      <span className="au-spinner" aria-hidden />
    </span>
  );
}
